import axios from '../axios'
import qs from 'qs';

/* 
 * 指标管理模块
 */

// 创建
export const add = (data) => {
    data = qs.stringify(data);
    return axios({
        url: '/kz/index/add',
        method: 'post',
        data
    })
}
// 查询
export const list = (data) => {
    data = qs.stringify(data);
    return axios({
        url: '/kz/index/list',
        method: 'post',
        data
    })
}
// 根据父级id查询子指标
export const children = (data) => {
    data = qs.stringify(data);
    return axios({
        url: '/kz/index/children',
        method: 'post',
        data
    })
}
// 单条查询
export const detail = (data) => {
    data = qs.stringify(data);
    return axios({
        url: '/kz/index/detail',
        method: 'post',
        data
    })
}
// 修改
export const update = (data) => {
    data = qs.stringify(data);
    return axios({
        url: '/kz/index/update',
        method: 'post',
        data
    })
}
// 删除
export const del = (data) => {
    data = qs.stringify(data);
    return axios({
        url: '/kz/index/delete',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/index.js